'use client';
import { Loading } from '@/shared/components/parts/Loading';
import { ConfirmForm } from './ConfirmForm';
import { usePointChargeTop } from './index.hook';

export const PointChargeTop: React.FC = () => {
  const { state } = usePointChargeTop();

  return (
    <>
      {state.pageStatus === 'INIT' && <Loading />}
      {state.pageStatus === 'CONFIRM' && <ConfirmForm state={state} />}
    </>
  );
};
